export default __webpack_public_path__ + "static/media/hero-img-3.1c39c4a0.jpg";